import {FaAward} from 'react-icons/fa'
import {TbBooks} from 'react-icons/tb'
import {BiHappyHeartEyes} from 'react-icons/bi'


const data = [
    {id: 1, icon: <FaAward/>, title: 'Experience', desc: '1+ Years Freelancing'},
    {id: 2, icon: <TbBooks/>, title: 'Projects', desc: '40+ Completed'},
    {id: 3, icon: <BiHappyHeartEyes/>, title: 'Clients', desc: '20+ happy clients'}
    ]



    export default data;